// Section used on member/journey screens
export default function MemberSection({ children, hideBorder = false }) {
  const borderClasses = !hideBorder ? 'border-b-2 border-primary-500' : '';
  return (
    <div className={`pb-4 ${borderClasses} mb-4`}>
      {children}
    </div>
  )
}
